/**
 * @fileoverview gRPC-Web generated client stub for wisetime.user.assistant.v4
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.4.2
// 	protoc              v3.14.0
// source: wisetime/user/assistant/v4/assistant.proto


/* eslint-disable */
// @ts-nocheck


import * as grpcWeb from 'grpc-web';

import * as wisetime_user_assistant_v4_assistant_pb from '../../../../wisetime/user/assistant/v4/assistant_pb';


export class AssistantServiceClient {
  client_: grpcWeb.AbstractClientBase;
  hostname_: string;
  credentials_: null | { [index: string]: string; };
  options_: null | { [index: string]: any; };

  constructor (hostname: string,
               credentials?: null | { [index: string]: string; },
               options?: null | { [index: string]: any; }) {
    if (!options) options = {};
    if (!credentials) credentials = {};
    options['format'] = 'text';

    this.client_ = new grpcWeb.GrpcWebClientBase(options);
    this.hostname_ = hostname.replace(/\/+$/, '');
    this.credentials_ = credentials;
    this.options_ = options;
  }

  methodDescriptorGenerateNarrative = new grpcWeb.MethodDescriptor(
    '/wisetime.user.assistant.v4.AssistantService/GenerateNarrative',
    grpcWeb.MethodType.UNARY,
    wisetime_user_assistant_v4_assistant_pb.GenerateNarrativeRequest,
    wisetime_user_assistant_v4_assistant_pb.GenerateNarrativeResponse,
    (request: wisetime_user_assistant_v4_assistant_pb.GenerateNarrativeRequest) => {
      return request.serializeBinary();
    },
    wisetime_user_assistant_v4_assistant_pb.GenerateNarrativeResponse.deserializeBinary
  );

  generateNarrative(
    request: wisetime_user_assistant_v4_assistant_pb.GenerateNarrativeRequest,
    metadata: grpcWeb.Metadata | null): Promise<wisetime_user_assistant_v4_assistant_pb.GenerateNarrativeResponse>;

  generateNarrative(
    request: wisetime_user_assistant_v4_assistant_pb.GenerateNarrativeRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: wisetime_user_assistant_v4_assistant_pb.GenerateNarrativeResponse) => void): grpcWeb.ClientReadableStream<wisetime_user_assistant_v4_assistant_pb.GenerateNarrativeResponse>;

  generateNarrative(
    request: wisetime_user_assistant_v4_assistant_pb.GenerateNarrativeRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: wisetime_user_assistant_v4_assistant_pb.GenerateNarrativeResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/wisetime.user.assistant.v4.AssistantService/GenerateNarrative',
        request,
        metadata || {},
        this.methodDescriptorGenerateNarrative,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/wisetime.user.assistant.v4.AssistantService/GenerateNarrative',
    request,
    metadata || {},
    this.methodDescriptorGenerateNarrative);
  }

  methodDescriptorBatchTranslateTexts = new grpcWeb.MethodDescriptor(
    '/wisetime.user.assistant.v4.AssistantService/BatchTranslateTexts',
    grpcWeb.MethodType.UNARY,
    wisetime_user_assistant_v4_assistant_pb.BatchTranslateTextsRequest,
    wisetime_user_assistant_v4_assistant_pb.BatchTranslateTextsResponse,
    (request: wisetime_user_assistant_v4_assistant_pb.BatchTranslateTextsRequest) => {
      return request.serializeBinary();
    },
    wisetime_user_assistant_v4_assistant_pb.BatchTranslateTextsResponse.deserializeBinary
  );

  batchTranslateTexts(
    request: wisetime_user_assistant_v4_assistant_pb.BatchTranslateTextsRequest,
    metadata: grpcWeb.Metadata | null): Promise<wisetime_user_assistant_v4_assistant_pb.BatchTranslateTextsResponse>;

  batchTranslateTexts(
    request: wisetime_user_assistant_v4_assistant_pb.BatchTranslateTextsRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: wisetime_user_assistant_v4_assistant_pb.BatchTranslateTextsResponse) => void): grpcWeb.ClientReadableStream<wisetime_user_assistant_v4_assistant_pb.BatchTranslateTextsResponse>;

  batchTranslateTexts(
    request: wisetime_user_assistant_v4_assistant_pb.BatchTranslateTextsRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: wisetime_user_assistant_v4_assistant_pb.BatchTranslateTextsResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/wisetime.user.assistant.v4.AssistantService/BatchTranslateTexts',
        request,
        metadata || {},
        this.methodDescriptorBatchTranslateTexts,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/wisetime.user.assistant.v4.AssistantService/BatchTranslateTexts',
    request,
    metadata || {},
    this.methodDescriptorBatchTranslateTexts);
  }

}

